import { ReactNode } from "react"

interface ButtonProps {
	theme: string | null
	children: ReactNode
	link: string | undefined
}

export default function Button({ theme, link, children }: ButtonProps) {
	return (
		<>
			<a href={link}>
			{theme == "inverse" ? (
				<div className="group relative border-2 border-white/30 hover:border-primary/60 bg-transparent hover:bg-primary/10 transition-all duration-300 ease-out lg:text-xl text-lg flex items-center justify-center lg:px-6 lg:py-4 px-4 py-2">
					<span className="text-white group-hover:text-primary transition-colors duration-300">{children}</span>
				</div>
			) : (
				""
			)}

			{theme == "default" ? (
				<div className="group relative border-2 border-white bg-white hover:bg-primary hover:border-primary transition-all duration-300 ease-out lg:text-xl text-lg flex items-center justify-center lg:px-6 lg:py-4 px-4 py-2">
					<span className="text-black group-hover:text-white transition-colors duration-300">{children}</span>
				</div>
			) : (
				""
			)}

				{theme == "white-bg" ? (
					<div className="bg-transparent hover:bg-black hover:text-white transition-colors ease-in-out duration-200 border-black text-black border-2 lg:text-xl text-lg flex items-center justify-center lg:px-6 lg:py-4 px-4 py-2">
						{children}
					</div>
				) : (
					""
				)}
			</a>
		</>
	)
}